import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;

  @media (max-width: 800px) {
    :not(:last-child) {
      margin-bottom: 5rem;
    }
  }
`;

const Circle = styled.div`
  border-radius: 50%;
  background-color: var(--accent-tint);
  color: var(--accent-deep);
  border: 1px solid var(--border);
  height: 8rem;
  width: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.label`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--ink-soft);
  margin-top: 1.2rem;
  text-align: center;
`;

export { Circle, Text, Container };
